import red from 'material-ui/colors/red';

const palette = {
    background: {
        //appBar: '#cfd8dc'
        //appBar: '#eceff1'
        info: '#e8ebfb',
            infoWarning: '#fbe9e7',
            infoError: '#fbe9e7'
    },
    primary: {
        50: '#e8eaf6',
            100: '#c5cae9',
            200: '#9fa8da',
            300: '#7986cb',
            400: '#5c6bc0',
            500: '#0e0048',
            600: '#3949ab',
            700: '#303f9f',
            800: '#283593',
            900: '#1a237e',
            A100: '#8c9eff',
            A200: '#536dfe',
            A400: '#3d5afe',
            A700: '#1a237e',
            contrastDefaultColor: 'light',
    },
    secondary: {
        50: '#fbe9e7',
            100: '#ffccbc',
            200: '#ffab91',
            300: '#ff8a65',
            400: '#ff7043',
            500: '#FF5F14',
            600: '#f4511e',
            700: '#e64a19',
            800: '#d84315',
            900: '#bf360c',
            A100: '#ff9e80',
            A200: '#ff6e40',
            A400: '#ff3d00',
            A700: '#dd2c00',
            contrastDefaultColor: 'light',
    },
    text: {
        disabled: '#000',
    },
};

const theme = {
    menu: {
        width: 250,
        height: (theme) => ({
            height: 56,
            [theme.breakpoints.up('md')]: {
                height: 64,
            }
        }),
        transition: (props) => `${props} 225ms cubic-bezier(0, 0, 0.2, 1) 0ms`
    },
    header: {
        height: 64,
        heightMobile: 56
    },
    palette,
    status: {
        danger: red,
    },
    spacing: {
        xsmall: 8,
        small: 16,
        normal: 24,
        large: 48,
        xlarge: 64,
        huge: 96,
    },
    zIndex: {
        appBar: 1030,
    },
    mixin: {
        link: () => {
            return {
                color: palette.primary[500],
                textDecoration: 'underline',
                '&:hover': {
                    color: palette.secondary[500],
                }
            }
        },
        danger: (palette) => {
            return {
                color: palette.getContrastText(red[500]),
                backgroundColor: red[500],
                '&:hover': {
                    backgroundColor: red[700],
                },
            }
        }
    }
};

export default theme;


// WEBPACK FOOTER //
// ./src/style/theme.js